<template>
  <transition name="slide-up">
    <div v-if="show" class="win-lose-drop-zones">
      <div
        v-if="!isAlreadyWon"
        class="drop-zone win-zone"
        :class="{ 'drag-over': winHover }"
        @dragover.prevent="winHover = true"
        @dragleave="winHover = false"
        @drop.prevent="onDropWin"
      >
        <fluent-icon icon="checkmark-circle" size="24" />
        <span>{{ $t('TICKET.WIN.BUTTON') }}</span>
      </div>
      <div
        v-if="!isAlreadyLost"
        class="drop-zone lose-zone"
        :class="{ 'drag-over': loseHover }"
        @dragover.prevent="loseHover = true"
        @dragleave="loseHover = false"
        @drop.prevent="onDropLose"
      >
        <fluent-icon icon="dismiss-circle" size="24" />
        <span>{{ $t('TICKET.LOSE.BUTTON') }}</span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ModalWinLoseChoice',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    ticket: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      winHover: false,
      loseHover: false,
    };
  },
  computed: {
    isAlreadyWon() {
      return this.ticket && this.ticket.status === 'gain';
    },
    isAlreadyLost() {
      return this.ticket && this.ticket.status === 'lose';
    },
  },
  watch: {
    show(val) {
      if (!val) {
        this.winHover = false;
        this.loseHover = false;
      }
    },
  },
  methods: {
    onDropWin() {
      this.winHover = false;
      this.$emit('win');
    },
    onDropLose() {
      this.loseHover = false;
      this.$emit('lose');
    },
  },
};
</script>

<style scoped>
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

.win-lose-drop-zones {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  display: flex;
  gap: 2px;
  pointer-events: auto;
}

.drop-zone {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-small);
  padding: var(--space-large) var(--space-normal);
  min-height: 90px;
  font-size: var(--font-size-large);
  font-weight: var(--font-weight-medium);
  cursor: default;
  transition: all 0.2s ease;
  border: 2px dashed transparent;
  user-select: none;
}

.win-zone {
  background: var(--s-50);
  color: var(--s-600);
  border-color: var(--s-200);
}

.win-zone.drag-over {
  background: #ecfdf5;
  border-color: #34d399;
  color: #065f46;
  transform: scale(1.02);
  box-shadow: inset 0 0 20px rgba(52, 211, 153, 0.15);
}

.lose-zone {
  background: var(--s-50);
  color: var(--s-600);
  border-color: var(--s-200);
}

.lose-zone.drag-over {
  background: #fef2f2;
  border-color: #f87171;
  color: #991b1b;
  transform: scale(1.02);
  box-shadow: inset 0 0 20px rgba(248, 113, 113, 0.15);
}
</style>
